import * as React from 'react';

var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SvgPayrollSolid = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 44,
  height: 44,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15 21H6a3 3 0 0 1-3-3v-1h10v2a2 2 0 0 0 2 2Zm0 0a2 2 0 0 0 2-2V5a2 2 0 1 1 2 2h-2m2-4H8a3 3 0 0 0-3 3v11",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5 17V6c0-1 .6-3 3-3h10.426C17.765 3.156 17 3.88 17 6v13c0 .667-.4 2-2 2s-2-1.333-2-2v-2H5ZM19 3a1.235 1.235 0 0 0-.574 0H19Zm-7.25 3.583a2.084 2.084 0 0 1 1.766 1.043.75.75 0 1 1-1.3.75.583.583 0 0 0-.55-.292h-.657a1.003 1.003 0 0 1-.018 0h-.658a.583.583 0 0 0 0 1.167h1.334a2.083 2.083 0 0 1 .083 4.165V14a.75.75 0 0 1-1.5 0v-.583a2.083 2.083 0 0 1-1.766-1.043.75.75 0 1 1 1.3-.749.584.584 0 0 0 .524.292h1.359a.583.583 0 1 0 0-1.167h-1.334a2.083 2.083 0 0 1-.083-4.165V6a.75.75 0 0 1 1.5 0v.582Z",
  fill: "currentColor"
})));

export { SvgPayrollSolid as default };
